<template>
  <div id="app">
    <nuxt-pwa-assets />
    
    <nuxt-layout>
      <nuxt-page />
    </nuxt-layout>

    <div id="modal-spot" />
  </div>
</template>

<script setup lang="ts">
function detectBrowser(): string {
  if (navigator.userAgent.includes('Chrome')) {
    return 'chrome';
  }
  if (navigator.userAgent.includes('Firefox')) {
    return 'firefox';
  }
  if (navigator.userAgent.includes('Safari')) {
    return 'safari';
  }

  return 'unknown';
}

onMounted(() => {
  document.body.classList.add(detectBrowser());
});
</script>

<style scoped lang="scss">
@import "assets/styles/main";
</style>
